import { useReduxState } from 'hooks';
import striptags from 'striptags';
import { useApiData } from 'lib/api';
import {
  CalendarEventDateIcon,
  CalendarEventDateString
} from 'components/calendar';
import {
  ContentValue,
  LoadingIndicator,
  RichTextValue
} from 'components/common';
import { HomeDetailsItem } from '.';

const HomeDetailsUpcomingEvents = () => {
  const { messages, theme } = useReduxState();

  const { data, loading } = useApiData({
    url:
      '/admin/calendar-events' +
      '?view=list' +
      '&timeFrame=current' +
      '&status=added' +
      '&limit=100'
  });

  const contentValueStyle = {
    color: theme.textColorLighter,
    fontSize: '1.5rem',
    fontWeight: 600
  };

  const contentValueIconStyle = {
    fontSize: '1.3rem',
    marginRight: 6
  };

  return loading ? (
    <LoadingIndicator />
  ) : (
    <div className="events">
      {data?.events.map((event) => (
        <HomeDetailsItem
          href={`/calendar/${event.id}`}
          key={event.id}
          category="default"
          timePrefix={messages.commonStarts}
          timeString={event.startDate}
        >
          <div className="icon">
            <CalendarEventDateIcon
              startDate={event.startDate}
              useMonthSpecifier={true}
            />
          </div>
          <div className="inner">
            <div className="title">{event.title}</div>
            <div className="info">
              <div className="time">
                <ContentValue
                  icon={['far', 'calendar-alt']}
                  iconStyle={contentValueIconStyle}
                  style={contentValueStyle}
                >
                  <CalendarEventDateString
                    startDate={event.startDate}
                    endDate={event.endDate}
                  />
                </ContentValue>
              </div>
              {event.location ? (
                <div className="location">
                  <ContentValue
                    icon="map-marker-alt"
                    iconStyle={contentValueIconStyle}
                    style={contentValueStyle}
                  >
                    {event.location}
                  </ContentValue>
                </div>
              ) : null}
            </div>
          </div>
        </HomeDetailsItem>
      ))}

      <style jsx>{`
        .events {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .inner {
          flex-grow: 1;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
        }
        .info {
          color: ${theme.textColorLighter};
          display: flex;
          flex-wrap: wrap;
          font-size: 1.4rem;
          font-weight: 600;
          gap: 5px 40px;
          margin-top: 4px;
        }
      `}</style>
    </div>
  );
};
export default HomeDetailsUpcomingEvents;
